import { render, staticRenderFns } from "./DomainsDataTable.vue?vue&type=template&id=0b61a67a&scoped=true&lang=html&"
import script from "./DomainsDataTable.vue?vue&type=script&lang=js&"
export * from "./DomainsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./DomainsDataTable.vue?vue&type=style&index=0&id=0b61a67a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b61a67a",
  null
  
)

export default component.exports